import { AscBadgeColor } from "@ascendnow/shared";
import { useEffect, useRef } from "react";
import {
  LargeBlueTicket,
  LargeGreenTicket,
  LargeOrangeTicket,
  LargePinkTicket,
  LargePurpleTicket,
} from "../AscIllustrations";

interface AscBadgeProps extends React.SVGProps<SVGSVGElement> {
  color: AscBadgeColor;
  noGaussianBlur?: boolean;
}

export default function AscBadge({
  color,
  noGaussianBlur = false,
  ...props
}: AscBadgeProps) {
  const svgRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (!noGaussianBlur || !svgRef.current) {
      return;
    }
    const feGaussianBlurElement =
      svgRef.current.querySelector("feGaussianBlur");
    if (feGaussianBlurElement) {
      feGaussianBlurElement.remove();
    }
  }, [noGaussianBlur]);

  switch (color) {
    case "TEAL":
      return <LargeBlueTicket ref={svgRef} {...props} />;
    case "PINK":
      return <LargePinkTicket ref={svgRef} {...props} />;
    case "GREEN":
      return <LargeGreenTicket ref={svgRef} {...props} />;
    case "ORANGE":
      return <LargeOrangeTicket ref={svgRef} {...props} />;
    case "PURPLE":
      return <LargePurpleTicket ref={svgRef} {...props} />;
  }
}
